module.exports = "<a ng-disabled=!date class=\"btn btn-default btn-xs\" ng-href={{url}}><span class=\"glyphicon glyphicon-remove-circle\" aria-hidden=true></span>&nbsp; <span class=\"hidden-xs ng-scope\" translate=\"New Spa\">New Spa</span></a>";


//////////////////
// WEBPACK FOOTER
// ./js/actions/rightsSpaReport.html
// module id = 437
// module chunks = 0